export default [
    {
        value: {
            value: 'approved',
            id: 2
        },
        label: 'Aprobada',
    }, {
        value: {
            value: 'rejected',
            id: 3
        },
        label: 'Rechazada',
    }, {
        value: {
            value: 'pending',
            id: 1
        },
        label: 'Pendiente',
    }
];
